import { useSelector } from 'react-redux';

import partnersSelector from 'redux/partner/selectors';

import { resolveSelectedStores } from '../domain';

export function useScheduledStoreIds(): number[] {
  const selected = useSelector(
    (state: any) => state.ordersReducer?.filter?.selectedStoresIds ?? [],
  );
  const partnerStores = useSelector(partnersSelector.selectStores);

  return resolveSelectedStores(selected, partnerStores);
}
